function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D27",
  d: "M18.961,1.5v34.921c0,0,7.565,0.262,12.518-5.294s5.209-4.416,4.943-12.167s-0.266-7.75-5.386-12.605 S18.961,1.5,18.961,1.5z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  cx: 18.961,
  cy: 18.961,
  r: 17.461
}), /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  x1: 18.958,
  y1: 36.421,
  x2: 18.958,
  y2: 1.5
}));

var SvgRightSelected = function SvgRightSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "37.921px",
    height: "37.921px",
    viewBox: "0 0 37.921 37.921",
    enableBackground: "new 0 0 37.921 37.921",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Right-Selected.f4bcfeb2.svg";
export { ForwardRef as ReactComponent };